import { useEffect, useRef } from "react";

/** Keep screen on while the component is mounted, when supported. */
export function useWakeLock(active = true) {
  const sentinelRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    if (!active) return;
    if (!("wakeLock" in navigator)) return;

    const acquire = async () => {
      try {
        sentinelRef.current = await navigator.wakeLock.request("screen");
        if (cancelled && sentinelRef.current) sentinelRef.current.release();
        sentinelRef.current?.addEventListener?.("release", () => {});
      } catch { /* user denied or feature blocked — ignore */ }
    };

    const onVisibility = () => {
      if (document.visibilityState === "visible") acquire();
    };

    acquire();
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      cancelled = true;
      document.removeEventListener("visibilitychange", onVisibility);
      try { sentinelRef.current?.release?.(); } catch { /* noop */ }
    };
  }, [active]);
}
